export class Notification {
  formatMessage: string;
  constructor(
    readonly id: string,
    readonly title: string,
    readonly message: string,
    readonly timestamp: String
  ) {
    this.formatMessage = message + '\n' + this.timestamp;
  }

  toMessageAndDateTime(): string {
    return `${this.message}<br/>${this.timestamp}`;
  }

  toString(): string {
    return this.id + ' : ' + this.message + ', by ' + this.message;
  }
}
